<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
     <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- <h4 style="text-align: left">
      <span v-if="packCount > 0">
        Félicitations ! {{ packCount }} <span v-if="packCount == 1">pack</span> <span v-else>packs</span> de formation déjà gagné(s) !
      </span>
      Plus que {{10 - points }} <span v-if=" 10 - points == 1">point</span> <span v-else>points</span>  pour gagner un de nos parcours de formation DDA
      <a href="https://bubbleinsupport.zendesk.com/hc/fr/categories/5600536369949-MES-QUESTIONS-FREQUENTES"
        target="_blank">(En savoir plus)</a>
    </h4> -->
    <b-navbar-nav class="nav align-items-center ml-auto">
      <!-- <locale /> -->
      <!-- <dark-Toggler class="d-none d-lg-block" /> -->
      <!-- <search-bar /> -->
      <!-- <cart-dropdown /> -->
      <b-button v-if="!isOnTarification && (currentUser.type_utilisateur != 'assureur')"  @click="ToTarification" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" size="md" class="mr-2">
        <feather-icon v-if="prospectDataFromFicheTier" icon="PlusIcon" />
        <span class="align-middle text-uppercase"> Réaliser un devis</span>
      </b-button>
      
      <notification-dropdown v-if="currentUser.type_utilisateur != 'assureur'"  />
      <user-dropdown />
    </b-navbar-nav>
  
  </div>
</template>

<script>
import {
  BLink, BNavbarNav,BButton
} from 'bootstrap-vue'
import Bookmarks from './components/Bookmarks.vue'
import Locale from './components/Locale.vue'
import SearchBar from './components/SearchBar.vue'
import DarkToggler from './components/DarkToggler.vue'
import CartDropdown from './components/CartDropdown.vue'
import NotificationDropdown from './components/NotificationDropdown.vue'
import UserDropdown from './components/UserDropdown.vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BLink,

    // Navbar Components
    BNavbarNav,
    Bookmarks,
    Locale,
    SearchBar,
    DarkToggler,
    CartDropdown,
    NotificationDropdown,
    UserDropdown,
    BButton
  },
  data()
  {
    return {
      currentUser: null,
    }
  },
  directives: {
    Ripple
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
    prospectDataFromFicheTier: {
      type: Object,
      default: null,
      required: false
    },
  },
  created() {
    this.getCurrentUser()
  },
 methods:{
    ToTarification(){
       this.$router.push('/quickwins/tarification')
    },
    getCurrentUser()
    {
      this.currentUser = JSON.parse(localStorage.getItem("userData"))
    },
  },
   computed: {
    isOnTarification() {
      return( this.$route.path === '/quickwins/tarification' || this.$route.name === 'projets-proposition' || this.$route.name === 'projets-souscription')
    }
  }
}
 
</script>
